import React, { Fragment, useEffect } from 'react';
import Header from "../../components/header/HeaderOne";
import SideHeader from "../../components/SideHeader";
import TemplateService from "../../templates/service";
import FooterThree from "../../components/footer/FooterThree";

const ContactPage = () => {
    useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'page_view',
            page_title: 'Contact',
            page_path: '/contact'
        });
    }, []);

    return (
        <Fragment>
            <Header classes={'position-static'}/>
            <SideHeader mobile={true}/>
            <TemplateService/>
            <FooterThree position={'static'}/>
        </Fragment>
    );
};

export default ContactPage;